import { cn } from '@/lib/utils'
import { FC, HTMLProps } from 'react'

interface ExecutionInputProps extends HTMLProps<HTMLDivElement> {
	onIncrease: () => void
	onDecrease: () => void
}

export const ExecutionInput: FC<ExecutionInputProps> = ({ onIncrease, onDecrease, ...rest }) => {
	return (
		<div {...rest} className={cn('flex items-center gap-3', rest.className)}>
			<button
				type='button'
				aria-label='-10 сек'
				onClick={onDecrease}
				className='h-[72px] min-w-0 flex-1 rounded-[22px] bg-[#D2F300] px-6 text-[46px] font-semibold leading-none tracking-[-0.03em] text-black transition-transform duration-150 ease-out active:scale-[0.97]'>
				-10 <span className='text-[19px] font-medium'>сек</span>
			</button>
			<button
				type='button'
				aria-label='+10 сек'
				onClick={onIncrease}
				className='h-[72px] min-w-0 flex-1 rounded-[22px] bg-white px-6 text-[46px] font-semibold leading-none tracking-[-0.03em] text-black ring-2 ring-[#BCD219] transition-transform duration-150 ease-out active:scale-[0.97]'>
				+10 <span className='text-[19px] font-medium'>сек</span>
			</button>
		</div>
	)
}
